<template>
    <Modal :show="show" :className="classOverride" @close="close">

      <ModalSuccess v-if="success" title="Kit successfully purchased" :bodyText="successBodyText" buttonText="OK" @close="closeSuccess()" />



      <div v-if="!success && currentPage === 0" class="page-0-content">
        <header class="feature myJourney"></header>
        <div class="modal-main text-center">

            <template v-if="giveAway">
                <h2 class="text-center">Buy a kit for someone else</h2>
                <p>You can choose how many kits your would like to purchase. Once payment is complete, these kits will appear in your "My Journey" page (after this window closes).</p>
                <p>From your "My Journey" page, you can share these kits by clicking the "Give kit to someone" button. This will allow you to enter their email address and send them a prompt to create an account and redeem the kit that you have shared. Kits that have been shared will then show in the "Kits given to others" tab on your "My Journey" page. </p>
            </template>
            <template v-else>
                <h2 v-if="!replacement" class="text-center">Add a kit to My Journey</h2>
                <h2 v-else class="text-center">Order Replacement Kit'</h2>
              <p>Continue monitoring your gut microbiome by adding another kit to your Microba Journey. Within the Microba Discovery Portal, you can compare new samples with previous samples.</p>
            </template>

            <div class="row">
            <div class="col-12">
                <button class="btn btn-primary" v-on:click="proceedToPayment()">Proceed</button>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <button class="btn plain" v-on:click="close"><em>Cancel</em></button>
            </div>
          </div>
        </div>
      </div>



      <div class="modal-main w-100" v-if="!success && currentPage == 1">

          <div class="modal-header row">

            <h2 class="col-12 modal-title">Select quantity & confirm payment details</h2>

          </div>

          <div class="modal-body w-100">

            <transition name="slide-fade">
              <div v-if="error" class="alert alert-danger" role="alert">
                {{error}}
              </div>
            </transition>

              <div class="col-md-4 col-12 offset-md-4">
                <div class="qtyBox clearfix">
                  <a  @click.prevent="qtyDecrease" href="#" class="btn btn-sm btn-outline-primary d-inline-block btnSub">-</a>
                  <span class="d-inline-block qtyValue">{{ qty }}</span>
                  <a @click.prevent="qtyIncrease" href="#" class="btn btn-sm btn-outline-primary d-inline-block btnAdd">+</a>
                </div>
              </div>

            <div class="col-12 text-center" style="font-size:22px; margin-top:30px; margin-bottom:30px;"><span>Microba <em>Insight</em> Sampling Kit</span></div>


            <div class="form-block" style="padding-top: 10px;">
              <div class="row ml-1 mr-1">
                <div class="col-md-7 text-md-left text-center totalTitle">
                  <span>Cart total</span>
                </div>
                <div class="col-md-5 text-md-right text-center">
                  <span class="totalValue d-inline-block">${{ formatMoney(getTotalPrice) }}</span>
                </div>
                <div class="col-12 text-right discountDetails" v-if="promoCode && promoCode.type!=='TRACKING'">
                  {{discountDetails}}
                </div>
              </div>
            </div>
            <div class="form-block">
              <div class="row ml-1 mr-1">

                  <div class="col-12">
                      <div class="row">

                          <div class="form-group col col-md-6">
                              <input
                                      type="text"
                                      class="form-control"
                                      v-validate="'required'"
                                      v-model="editedUser.firstName"
                                      required
                                      placeholder="First name" />
                          </div>
                          <div class="form-group col col-md-6">
                              <input
                                      type="text"
                                      class="form-control"
                                      v-validate="'required'"
                                      v-model="editedUser.lastName"
                                      required
                                      placeholder="Last name" />
                          </div>

                      </div>
                  </div>
              </div>

              <div class="row  ml-1 mr-1">
                  <div class="form-group col col-md-12">
                      <Card class='stripe-card form-control'
                            :class='{ complete }'
                            :stripe="PurchaseStripeKey"
                            :options='stripeOptions'
                            @change='onStripeChange'
                      />
                  </div>
              </div>
            </div>

            <div class="form-block">
              <div class="row ml-1 mr-1">

                <div class="col-12">
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <div class="input-group">
                        <input type="text" class="form-control practitioner-referral-code" v-model="editedUser.referralCode"
                               @input="validatePractitionerReferralCode" :class="{'is-invalid': editedUser.referralCode && !validatingReferralCode &&  !isPractitionerReferralCodeValid }"
                               placeholder="Enter referral code">
                        <div class='invalid-feedback'>
                          Invalid code
                        </div>
                        <div class='input-group-append' :class="{'is-invalid-Helper': editedUser.referralCode }">

                          <!--<span v-if="!editedUser.referralCode" class='input-group-text practitioner-referral-code  helper-icon border-0' >?</span>-->
                          <span v-if="editedUser.referralCode  && !validatingReferralCode && !isPractitionerReferralCodeValid" class="input-group-text practitioner-referral-code border-0 is-invalid text-danger">!</span>
                          <span v-else-if="editedUser.referralCode && !validatingReferralCode  && isPractitionerReferralCodeValid" class='input-group-text practitioner-referral-code border-0 valid text-success'>
                            <i class="fas fa-check "></i>
                          </span>
                          <span v-else-if="validatingReferralCode" class="input-group-text practitioner-referral-code border-0">
                            <i class="fas fa-circle-notch fa-spin"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-6 col-12">
                      <div class="input-group">
                        <input type="text" class="form-control practitioner-referral-code" v-model="editedUser.participantCode"
                               @input="validatePromotionalCode" :class="{'is-invalid': editedUser.participantCode && !validatingPromotionalCode &&  !isPromotionalCodeValid }"
                               placeholder="Enter a promotion code">
                        <div class='invalid-feedback'>
                          Invalid code
                        </div>
                        <div class='input-group-append' :class="{'is-invalid-Helper': editedUser.participantCode }">

                          <!--<span v-if="!editedUser.referralCode" class='input-group-text practitioner-referral-code  helper-icon border-0' >?</span>-->
                          <span v-if="editedUser.participantCode  && !validatingPromotionalCode && !isPromotionalCodeValid" class="input-group-text practitioner-referral-code border-0 is-invalid text-danger">!</span>
                          <span v-else-if="editedUser.participantCode && !validatingPromotionalCode  && isPromotionalCodeValid" class='input-group-text practitioner-referral-code border-0 valid text-success'>
                            <i class="fas fa-check "></i>
                          </span>
                          <span v-else-if="validatingPromotionalCode" class="input-group-text practitioner-referral-code border-0">
                            <i class="fas fa-circle-notch fa-spin"></i>
                          </span>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="modal-footer">

              <Button
                class="btn btn-primary"
                @onClick="validatePay"
                text="Confirm payment"
                :loading="loading"
              />
              <!--<button class="btn plain" v-on:click="currentPage = 0"><em>Back</em></button>-->
          </div>

      </div><!-- END PAGE 2 -->

    </Modal>
</template>

<script>
import Modal from '@/components/models/Modal'
import ModalAddress from '@/components/models/components/ModalAddress'
import ModalSuccess from '@/components/models/components/ModalSuccess'
import UserMixins from '@/mixins/userProfile'
import PurchaseKit from '@/mixins/purchaseKits'
import { Card, createToken } from 'vue-stripe-elements-plus'
import Button from '@/components/elements/DynamicButton'
import debounce from 'tiny-debounce'
import microbaAnalytics from '@/services/microbaAnalytics'

export default {
  name: 'ModalOrder',
  props: {
    show: Boolean,
    giveAway: Boolean,
    replacement: Boolean,
    title: String,
    kitID: String,
    heading: String,
    showIntro: {
      type: Boolean,
      default: true
    },
    copy: String,
    product: {
      type: Object,
      required: true,
      validator: function (value) {
        return typeof value.amount === 'number' &&
        typeof value.label === 'string' &&
        typeof value.orderType === 'string'
      }
    }
  },
  mixins: [ UserMixins, PurchaseKit ],
  extends: Modal,
  components: {
    Modal,
    ModalAddress,
    ModalSuccess,
    Button,
    Card
  },
  mounted: function () {
    this.editedUser = this.user
  },
  data: function () {
    return {
      isEditing: false,
      currentPage: (this.showIntro) ? 0 : 1,
      loading: false,
      editedUser: {
        firstName: '',
        lastName: '',
        addressLine1: '',
        addressLine2: '',
        suburb: '',
        postcode: '',
        referralCode: '',
        participantCode: ''
      },
      practitioner: {
        firstName: '',
        lastName: ''
      },
      qty: 1,
      complete: false,
      stripeComplete: false,
      success: false,
      error: null,
      isPractitionerReferralCodeValid: null,
      validatingReferralCode: false,
      isPromotionalCodeValid: null,
      validatingPromotionalCode: false,
      referralCodeValid: null,
      promoCode: null
    }
  },
  computed: {
    successBodyText () {
      if (this.replacement) {

      } else {
        return "This kit will now appear in the 'My Kits' page where you can choose to send it to yourself or someone else. Please proceed to this page to make your selection."
      }
    },

    getTotalPrice () {
      let price = this.product.amount
      if (this.promoCode) {
        if (this.promoCode.type === 'AMOUNT') {
          price = price - this.promoCode.value
        } else if (this.promoCode.type === 'PERCENTAGE') {
          price = price - ((price * this.promoCode.value) / 100)
        }
      }
      return (this.qty * price)
    },
    user: function () {
      return this.$store.state.GET_USER_RESPONSE || false
    },
    stripeOptions: function () {
      return {
        displayItems: [this.product],
        style: {
          base: {
            // Add your base input styles here. For example:
            'fontSize': '16px'
          }
        }
      }
    },
    purchaseObject: function () {
      let kitDtos = [{
        orderItemType: 'KIT',
        deliveryOption: 'SEND_LATER',
        referralCode: this.editedUser.referralCode.replace('REF', ''),
        promotionalCode: this.editedUser.participantCode,
        email: this.user.email
      }]
      if (!this.replacement) {
        for (let i = 1; i < this.qty; i++) {
          kitDtos.push({
            orderItemType: 'KIT',
            deliveryOption: 'SEND_LATER',
            referralCode: this.editedUser.referralCode,
            promotionalCode: this.editedUser.participantCode,
            email: this.user.email
          })
        }
      }

      return (this.user) ? {
        purchaserEmail: this.user.email,
        purchaserFirstName: this.user.firstName,
        purchaserLastName: this.user.lastName,
        orderType: this.product.orderType,
        replacingKitId: this.kitID,
        orderItems: kitDtos,
        amount: this.product.amount
      } : null
    },
    classOverride: function () {
      return 'page-' + this.currentPage
    },
    discountDetails: function () {
      const discount = this.promoCode.type === 'AMOUNT' ? `$${this.promoCode.value}` : `${this.promoCode.value}%`
      return `Discount ${discount} per kit`
    }
  },
  methods: {
    validatePractitionerReferralCode () {
      if (this.editedUser.referralCode) {
        this.isPractitionerReferralCodeValid = null
        this.validatingReferralCode = true
        this.editedUser.referralCode = this.editedUser.referralCode.toUpperCase()
        this.debounceReferralCodeValidation()
      }
    },
    debounceReferralCodeValidation: debounce(async function () {
      if (this.editedUser.referralCode) {
        await this.$store.dispatch('checkReferralCode', this.editedUser.referralCode.replace('REF', ''))
          .then((response) => {
            this.practitioner.firstName = response.data.firstName
            this.practitioner.lastName = response.data.lastName
            this.isPractitionerReferralCodeValid = true
            this.validatingReferralCode = false
          })
          .catch(() => {
            this.practitioner.firstName = ''
            this.practitioner.lastName = ''
            this.isPractitionerReferralCodeValid = false
            this.validatingReferralCode = false
          })
      }
    }, 2500),
    validatePromotionalCode () {
      this.isPromotionalCodeValid = null
      this.promoCode = null
      if (this.editedUser.participantCode) {
        this.editedUser.participantCode = this.editedUser.participantCode.toUpperCase()
        this.validatingPromotionalCode = true
        this.debouncePromotionalCodeValidation()
      }
    },
    debouncePromotionalCodeValidation: debounce(async function () {
      if (this.editedUser.participantCode) {
        await this.$store.dispatch('getPromoCode', this.editedUser.participantCode)
        .then((response) => {
          this.isPromotionalCodeValid = true
          this.validatingPromotionalCode = false
          this.promoCode = response.data
        })
        .catch(() => {
          this.isPromotionalCodeValid = false
          this.validatingPromotionalCode = false
        })
      }
    }, 2000),
    closeSuccess () {
      this.$store.dispatch('getUserKits')
      this.$router.push('kits')
      this.$emit('close')
    },
    formatMoney (val) {
      return val.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    },
    qtyIncrease () {
      this.qty++
    },

    qtyDecrease () {
      if (this.qty > 1) {
        this.qty --
      }
    },
    onShow: function () {
      if (this.currentPage < 1) {
        microbaAnalytics.trackItemsAdded(1, 'Microba Single Kit', this.product.amount, this.qty, 'SINGLE', this.editedUser.participantCode)
      }
      this.loading = false
      this.editedUser = Object.assign({}, this.user)
      this.currentPage = (this.showIntro) ? 0 : 1
      this.complete = false
      this.stripeComplete = false
      this.success = false
      this.qty = 1
      this.isEditing = false
      this.isPractitionerReferralCodeValid = null
      this.validatingReferralCode = false
      this.isPromotionalCodeValid = null
      this.validatingPromotionalCode = false
      this.referralCodeValid = null
      this.practitioner = {
        firstName: '',
        lastName: ''
      }
      this.editedUser.referralCode = ''
      this.editedUser.participantCode = ''
      this.error = ''
    },
    onStripeChange: function (e) {
      this.stripeComplete = e.complete
    },
    validatePay: function () {
      if (this.loading) {
        return
      }

      this.loading = true
      if (!this.stripeComplete) {
        this.loading = false
        this.error = 'Please complete credit card information.'
      } else if (this.errors.any()) {
        this.loading = false
        this.error = 'Problems detected in the form.'
      } else if (!this.isPromotionalCodeValid && this.editedUser.participantCode.length > 1) {
        this.loading = false
        this.error = 'Incorrect promotional code.'
      } else if (!this.isPractitionerReferralCodeValid && this.editedUser.referralCode.length > 1) {
        this.loading = false
        this.error = 'Incorrect referral code.'
      } else {
        this.pay()
      }
    },
    pay: function () {
      createToken().then(data => {
        if (data.error) {
          this.error = data.error.message
        } else {
          const stripeToken = data.token.id
          const description = this.product.label
          const payload = {...this.purchaseObject, stripeToken, description}
          this.error = null
          this.success = false
          this.$store.dispatch('postOrder', payload).then(success => {
            microbaAnalytics.trackPurchase(stripeToken, 1, 'Microba Single Kit', this.product.amount, this.qty, 'SINGLE', this.editedUser.participantCode, this.getTotalPrice)
            // Activate the kit after purhcase
            this.$store.dispatch('getUserKits')
            this.$store.dispatch('getSentKits')
            this.loading = false
            this.success = true
            this.error = null
          }).catch(error => {
            console.log(error)
            this.loading = false
            this.success = false

            // Refresh regardless
            this.$store.dispatch('getUserKits')
            this.$store.dispatch('getSentKits')

            // Map some specific errors or return server message
            switch (error.response.status) {
              case 402:
                this.error = 'Your credit card transaction has been rejected.'
                break
              case 500:
                this.error = 'We have experienced some technical issue with payment. Please try again. If problem persist, please contact us at 1300 974 621.'
                break
              default:
                this.error = error.response.data.message
            }
          })
        }
      }).catch(error => {
        this.error = error.response.data.message
      })
    },
    proceedToPayment: function () {
      this.currentPage = 1
      this.promoCode = null
    }
  }
}
</script>

<style scoped lang="scss">
.qtyBox {
  background: #f2f2f2;
  margin-bottom: 20px;
  height: 52px;

  span {
    width: 100%;
    font-size: 24px;
    text-align: center;
    padding-top: 8px;
  }

  a {
    border-radius: 10px;
    background: #589eca;
    color: #dbebf4;
    border: none;
    font-size: 24px;
    padding: 8px 0px;
    width: 48px !important;
    text-align: center;

    &.btnSub {
      position: absolute;
      left: 0;
      top: 0;

    }

    &.btnAdd {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
}

.totalTitle {
  font-weight: lighter;
  font-size: 26px;
}

.totalValue {
  font-weight: normal;
  font-size: 26px;
}

.discountDetails{
  font-style: italic;
  font-size: 16px;
  color: #ff8708;
}

.form {
  padding-top: 1rem;
  margin-top: 1rem;
}

#totalBox {
  padding-top: 40px;
  padding-bottom: 36px;
  background: #f4f4f4;
  margin-bottom: 26px;
}

#totalBox .btn-sm {
  padding: 0.025rem 0.5rem;
  border-radius: 3px;
}

#totalBox .qtyValue {
  width: calc(100% - 60px);
  text-align: center;
  padding-top: 3px;
}


   .input-group-text{
     background:transparent;
   }
   .input-group-append {
     margin-left: -1px;
     position: absolute;
     right: 0;
     z-index:999999;
   }

   .form-control{
     border:0px;
   }

#totalBox .qtyValueReplace {
  width: 100%;
  text-align: center;
  padding-top: 3px;
}

#totalBox .qtyValueTitle {
  padding-top: 3px;
}

#totalBox .qtyBox {
  border: 1px solid #dbdbdb;
  padding: 5px;
}

#totalRow {
  background: #fff;
  border: 1px solid #dbdbdb;
  margin-top: 20px;
}

.totalRowPadding {
  margin-left: 40px;
  margin-right: 40px;
  padding-top: 15px;
  padding-bottom: 15px;
}


</style>



// WEBPACK FOOTER //
// src/components/models/ModalOrder.vue